document.addEventListener('DOMContentLoaded', function () {
  if (typeof Shopify !== 'undefined' && Shopify.designMode) return;
  if (/(^|\/)search(\/|$)/i.test(String(window.location.pathname || ''))) return;

  var container = document.querySelector('.cust-load-more.cust-load-more--active');
  if (!container) return;

  var btn = container.querySelector('[data-cust-load-more-trigger]');
  // Control element: holds paging / load config via data-* attributes.
  var control = container.querySelector('[data-cust-load-more-control]');
  var grid = container.querySelector('#main-collection-product-grid');
  if (!btn || !control || !grid) return;

  var busy = false;
  var hidden = [];
  var cache_u = ''; // Prefetch cache URL key
  var cache_h = '';
  var page = parseInt(control.getAttribute('data-cust-load-more-current-page'), 10);
  var last_is_mobile = is_mobile();
  if (!Number.isFinite(page) || page < 1) page = 1;

  // Product cards only (exclude collection promo banners).
  var coll_sel = '.product-item:not(.clp-promotional-banner):not(.custom-clp-promotion__banner)';
  var sec_id = control.getAttribute('data-cust-load-more-section-id') || '';
  var grid_sel = sec_id
    ? '#main-collection-product-grid[data-id="' + sec_id + '"]'
    : '#main-collection-product-grid';

  function sleep_ms(ms) {
    return new Promise(function (resolve) { setTimeout(resolve, ms); });
  }

  /** Parse integer data-* attribute; fb = fallback. */
  function read_int(el, name, fb) {
    var v = parseInt(el && el.getAttribute(name), 10);
    return Number.isFinite(v) ? v : fb;
  }

  function is_mobile() {
    try { return window.matchMedia('(max-width: 767px)').matches; } catch (e) { return false; }
  }

  function read_batch() {
    var attr = is_mobile() ? 'data-cust-load-more-batch-mobile' : 'data-cust-load-more-batch-desktop';
    var n = parseInt(control.getAttribute(attr), 10);
    if (Number.isFinite(n) && n > 0) return n;
    return is_mobile() ? 20 : 100;
  }

  function list_cards() {
    return Array.prototype.slice.call(grid.querySelectorAll(coll_sel));
  }

  /** Count visible product cards (not in hidden queue, not display:none). */
  function count_visible() {
    var hidden_set = typeof Set === 'function' ? new Set(hidden) : null;
    var list = list_cards();
    var n = 0;
    for (var j = 0; j < list.length; j++) {
      if (hidden_set ? hidden_set.has(list[j]) : hidden.indexOf(list[j]) !== -1) continue;
      if (list[j].style.display === 'none') continue;
      n++;
    }
    if (n === 0 && list.length > 0) return Math.max(0, list.length - hidden.length);
    return n;
  }

  function has_next() {
    var r = control.getAttribute('data-cust-load-more-next-url');
    return !!(r && String(r).trim());
  }

  function lazy_load(el) {
    var imgs = el.querySelectorAll ? el.querySelectorAll('img') : [];
    for (var i = 0; i < imgs.length; i++) {
      if (!imgs[i].getAttribute('loading')) imgs[i].setAttribute('loading', 'lazy');
      if (!imgs[i].getAttribute('decoding')) imgs[i].setAttribute('decoding', 'async');
    }
  }

  /** Update "Load N more", viewing range, and button visibility. */
  function paint_ui() {
    var label = control.querySelector('[data-cust-load-more-action-label]');
    var ms = control.querySelector('[data-cust-load-more-meta-start]');
    var me = control.querySelector('[data-cust-load-more-meta-end]');
    var mt = control.querySelector('[data-cust-load-more-meta-total]');
    var batch = read_batch(); // Batch size for current viewport
    var shown = count_visible(); // Visible product count
    var cat = read_int(control, 'data-cust-load-more-catalog-total', 0); // Catalog total for meta
    if (!Number.isFinite(cat) || cat < 0) cat = shown;
    var remain_total = Math.max(cat - shown, 0);
    var can_fetch = has_next();
    var left = hidden.length + (can_fetch ? batch : 0); // Rough remaining load capacity
    var next = Math.min(Math.max(batch, 1), Math.max(Math.min(left, remain_total), 0));
    var n_load = next > 0 ? next : can_fetch ? batch : 0;

    if (label) label.textContent = n_load > 0 ? 'Load ' + n_load + ' more' : '';
    if (ms) ms.textContent = shown > 0 ? '1' : '0';
    if (me) me.textContent = String(shown);
    if (mt) mt.textContent = String(Math.max(cat, shown));

    var on = remain_total > 0 && (has_next() || hidden.length > 0);
    btn.style.display = on ? '' : 'none';
  }

  /** Desktop: show all. Mobile: show first batch only; rest go to hidden[]. */
  function reset_cards() {
    var all = list_cards();
    for (var i = 0; i < all.length; i++) all[i].style.display = '';
    hidden = [];
    if (!is_mobile()) return;
    var cap = Math.min(Math.max(read_batch(), 1), all.length);
    for (var j = cap; j < all.length; j++) {
      all[j].style.display = 'none';
      hidden.push(all[j]);
    }
  }

  /** Reveal up to n cards from hidden queue. */
  function reveal_n(n) {
    var k = Math.min(n, hidden.length);
    for (var i = 0; i < k; i++) {
      var card = hidden.shift();
      card.style.display = '';
      lazy_load(card);
    }
    return k;
  }

  /** Copy pager data-* from fetched document onto the live control. */
  function sync_pager(doc) {
    var sid = control.getAttribute('data-cust-load-more-section-id') || '';
    var remote = sid
      ? doc.querySelector('[data-cust-load-more-control][data-cust-load-more-section-id="' + sid + '"]')
      : null;
    if (!remote) remote = doc.querySelector('[data-cust-load-more-control]');
    if (!remote) return;
    var nu = remote.getAttribute('data-cust-load-more-next-url');
    if (nu) control.setAttribute('data-cust-load-more-next-url', nu);
    else control.removeAttribute('data-cust-load-more-next-url');
    var cp = remote.getAttribute('data-cust-load-more-current-page');
    var tp = remote.getAttribute('data-cust-load-more-total-pages');
    var cat = remote.getAttribute('data-cust-load-more-catalog-total');
    if (cp) {
      page = parseInt(cp, 10) || page;
      control.setAttribute('data-cust-load-more-current-page', cp);
    }
    if (tp) control.setAttribute('data-cust-load-more-total-pages', tp);
    if (cat) control.setAttribute('data-cust-load-more-catalog-total', cat);
  }

  async function fetch_retry(url, try_n) {
    try_n = try_n || 0;
    var res = await fetch(url, {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'text/html,application/xhtml+xml', 'X-Requested-With': 'XMLHttpRequest' }
    });
    if (res.status === 429 && try_n < 5) {
      await sleep_ms(500 + try_n * 350);
      return fetch_retry(url, try_n + 1);
    }
    if (!res.ok) throw new Error('HTTP error! status: ' + res.status);
    return res.text();
  }

  async function load_html(url) {
    if (cache_u && cache_h && cache_u === url) {
      var h = cache_h;
      cache_u = '';
      cache_h = '';
      return h;
    }
    return fetch_retry(url, 0);
  }

  /** Prefetch next page HTML into cache (background). */
  function prefetch_next() {
    cache_u = '';
    cache_h = '';
    var raw = control.getAttribute('data-cust-load-more-next-url');
    if (!raw || !String(raw).trim()) return;
    var want = new URL(String(raw).trim(), window.location.href).toString();
    setTimeout(function () {
      var raw2 = control.getAttribute('data-cust-load-more-next-url');
      if (!raw2 || !String(raw2).trim()) return;
      var u = new URL(String(raw2).trim(), window.location.href).toString();
      if (u !== want) return;
      fetch_retry(u, 0).then(function (text) {
        var check = control.getAttribute('data-cust-load-more-next-url');
        if (!check) return;
        var still = new URL(String(check).trim(), window.location.href).toString();
        if (still !== u) return;
        cache_u = u;
        cache_h = text;
      }).catch(function () {});
    }, 450);
  }

  function next_url() {
    var tp = read_int(control, 'data-cust-load-more-total-pages', 0);
    var np = page + 1;
    if (tp > 0 && np > tp) return '';
    var u = new URL(window.location.href);
    u.searchParams.set('page', String(np));
    return u.toString();
  }

  reset_cards();
  paint_ui();
  prefetch_next();

  window.addEventListener('resize', function () {
    var mobile = is_mobile();
    if (mobile === last_is_mobile) return;
    last_is_mobile = mobile;
    reset_cards();
    paint_ui();
    prefetch_next();
  });

  btn.addEventListener('click', function () {
    if (busy) return;
    busy = true;
    var url = '';

    function done() {
      busy = false;
      paint_ui();
      prefetch_next();
    }

    // Desktop: fetch next page and append product nodes.
    if (!is_mobile()) {
      Promise.resolve().then(function () {
        var na = control.getAttribute('data-cust-load-more-next-url');
        if (na && String(na).trim()) url = new URL(String(na).trim(), window.location.href).toString();
        else url = next_url();
        return load_html(url).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var remote = doc.querySelector(grid_sel) || doc.querySelector('#main-collection-product-grid');
          var items = remote ? remote.querySelectorAll(coll_sel) : [];
          if (items.length) {
            items.forEach(function (node) { grid.appendChild(node); });
            lazy_load(grid);
          }
          sync_pager(doc);
        });
      }).catch(function () {}).finally(done);
      return;
    }

    // Mobile: reveal from hidden[] first; fetch next page if still short.
    var batch = read_batch();
    var got = reveal_n(batch);
    paint_ui();

    function fill_mobile() {
      var need = batch - got;
      if (need <= 0 || !has_next()) return Promise.resolve();
      var raw = control.getAttribute('data-cust-load-more-next-url');
      var u = '';
      try {
        if (raw && String(raw).trim()) u = new URL(String(raw).trim(), window.location.href).toString();
      } catch (e) {}
      if (!u) u = next_url();
      if (!u) return Promise.resolve();

      // Fetch HTML, append nodes, queue overflow in hidden[], then reveal up to need.
      return sleep_ms(100).then(function () {
        return load_html(u);
      }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var remote = doc.querySelector(grid_sel) || doc.querySelector('#main-collection-product-grid');
        var list = remote ? Array.prototype.slice.call(remote.querySelectorAll(coll_sel)) : [];
        var added = 0;
        // Newly appended items start hidden until reveal_n pulls them out.
        if (list.length) {
          for (var i = 0; i < list.length; i++) grid.appendChild(list[i]);
          lazy_load(grid);
          var all = list_cards();
          var tail = all.slice(all.length - list.length);
          for (var j = 0; j < tail.length; j++) {
            tail[j].style.display = 'none';
            hidden.push(tail[j]); 
          }
          added = list.length;
        }
        sync_pager(doc);
        if (added) got += reveal_n(need);
        paint_ui();
        if (!added) return Promise.resolve();
        need = batch - got;
        if (need > 0 && has_next()) return fill_mobile();
      }).catch(function () {});
    }

    fill_mobile().catch(function () {}).finally(done);
  });
});
